import React from "react";
import { useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../_metronic";
import { formatarNome } from "../../utils/Utils";

const getInicial = (nome) => {
	if (!nome || typeof nome !== "string" || nome.trim() === "") {
		return "";
	}

	return nome.trim().charAt(0).toUpperCase();
}

export default function UserProfile() {
	const { user } = useSelector(({ auth }) => auth);

	const foto_url = user?.foto?.url || toAbsoluteUrl("/images/no-profile.png");
	const tem_foto = Boolean(user?.foto?.url);
	const inicial = getInicial(user?.usr_nome);

	return (
		<div className="c-user-profile">
			<div
				className="avatar-40"
				style={{
					backgroundImage: tem_foto ? `url(${foto_url})` : "none"
				}}
				title={inicial}
			>
				{!tem_foto && inicial ? <span className="inicial">{inicial}</span> : null}
			</div>
			<span className="c-user-profile-nome">{formatarNome(user.usr_nome)}</span>
		</div>
	);
}
